import(/* webpackMode: "eager" */ "/builds/immoplus/bc-front-immoplus/src/app/(root)/error.tsx");
